enum FilesUploadingErrorActions {
  STORAGE_LIMITATION_REACHED_DIALOG,
  FILE_SIZE_NOT_SUPPORTED_DIALOG_LARGE,
  FILE_SIZE_NOT_SUPPORTED_DIALOG_SMALL,
}

export default FilesUploadingErrorActions;
